import '@assets/styles/pages/dealer-details.scss';
import { ReactElement, useEffect } from 'react';
import { useFormik } from 'formik';
import { PrimaryDetailList } from '@components/endUserDetails/components/moreDetailsForm/primaryDetailList';
import { defaultDealerDetailFormInitialValues, defaultPrimaryDetails } from '.';
import { getDealerDetails } from '@helper/utils';
import { useMoreDetailsQuery } from '@services/hooks/enduser-details/useMoreDetailQuery';
import { Wrapper } from '@components/common/Wrapper/wrapper';
import { useEndUserStore } from '@store/enduser';
import { useStoreFormikFormValue } from '@store/setFormikFormValueStore';

export const DealerDetails = (): ReactElement => {
	const { isFormEdit, formId } = useEndUserStore();
	const {
		data: getMoreDetailFormData,
		isFetching: isMoreDetailFetching,
		error,
	} = useMoreDetailsQuery(formId, isFormEdit);
	const { storedFormikValues } = useStoreFormikFormValue();

	const formik = useFormik({
		initialValues: defaultDealerDetailFormInitialValues,
		onSubmit: () => {},
	});

	useEffect(() => {
		if (storedFormikValues) {
			formik.setValues(storedFormikValues);
			return;
		}
		if (formId && getMoreDetailFormData && Object.keys(getMoreDetailFormData).length > 0) {
			const primaryDetailsArr = getDealerDetails(getMoreDetailFormData);
			const values = {
				...formik.values,
				primary_details: primaryDetailsArr.length > 0 ? primaryDetailsArr : defaultPrimaryDetails,
			};
			formik.setValues(values);
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [getMoreDetailFormData, formId, isFormEdit, storedFormikValues]);

	return (
		<section className="dealer-details-section">
			<Wrapper isLoaderVisible={isMoreDetailFetching} isError={error}>
				<div className="container">
					<form onSubmit={formik.handleSubmit}>
						<ul className="user-details-wrapper row">
							{formik.values.primary_details.map((dealer, index) => (
								<PrimaryDetailList
									key={dealer.id}
									formik={formik}
									primaryListIndex={index}
									dealer={dealer}
									fieldName="primary_details"
									isEditing={true}
									isDealerDetail={true}
								/>
							))}
						</ul>
					</form>
				</div>
			</Wrapper>
		</section>
	);
};
